import { render, staticRenderFns } from "./SurveyFinish.vue?vue&type=template&id=28591e80&scoped=true&"
import script from "./SurveyFinish.vue?vue&type=script&lang=js&"
export * from "./SurveyFinish.vue?vue&type=script&lang=js&"
import style0 from "./SurveyFinish.vue?vue&type=style&index=0&id=28591e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28591e80",
  null
  
)

export default component.exports